import { render, staticRenderFns } from "./Lacoste.vue?vue&type=template&id=153105bb&scoped=true&"
import script from "./Lacoste.vue?vue&type=script&lang=js&"
export * from "./Lacoste.vue?vue&type=script&lang=js&"
import style0 from "./Lacoste.vue?vue&type=style&index=0&id=153105bb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153105bb",
  null
  
)

export default component.exports